import * as React from 'react';
import {
    Card,
    MultiRowColumn,
    SimpleTable,
    SimpleTableHeader,
    StatusColumn,
} from 'components';
import { connect } from 'react-redux';
import { PaginationImpl } from 'components/defaultValues';
import { MappedExpertChangeRequestStatus, MappedExpertChangeRequestType } from 'components/enums';
import { Color, ColorStatus } from '_helpers';
import { useLoading } from 'hooks';
import { Dispatch, IRootState } from '../../../redux/store/configureStore';
import InfoModal from './InfoModal';
import EmptyListIcon from 'components/assets/svg/edit_file.svg';

const ChangeTab: React.FC<IProps> = (props) => {
    React.useEffect(() => {
        props.getCurrentExpertChangeRequests({});
    }, []);

    const [showExpertChangesModal, setShowExpertChangesModal] = React.useState(false);
    const [fetchExpertChangeRequestProcessing, fetchExpertChangeRequest] = useLoading((id: string) => props.getExpertChangeRequest(id));

    const handleOpenModal = (id: string) => {
        setShowExpertChangesModal(true);
        fetchExpertChangeRequest(id);
    };

    const handleCloseModal = () => {
        setShowExpertChangesModal(false);
        props.clearExpertChangeRequest();
        props.getCurrentExpertChangeRequests({});
    };

    const tableRows = props.expertChangeRequests ? props.expertChangeRequests.items.map((c, i) => ({
        id: c.id || `${i}`,
        columns: [
            c.dateTime ? c.dateTime.format('DD.MM.YYYY') : '',
            <MultiRowColumn
              rows={[c.fullName, c.placeOfWork, c.position]}
            />,
            c.requestType ? MappedExpertChangeRequestType[c.requestType].text : '',
            <StatusColumn
              status={c.status ? MappedExpertChangeRequestStatus[c.status] : new ColorStatus(Color.Default, '')}
            />,
        ],
    })) : [];

    const tableHeaders: SimpleTableHeader[] = [
        { title: 'ДАТА СОЗДАНИЯ', columnStyles: { width: '15%' } },
        { title: 'ФИО ЧЛЕНА КОМИССИИ', columnStyles: { width: '50%' } },
        { title: 'ТИП ЗАПРОСА', columnStyles: { width: '20%' } },
        { title: 'СТАТУС', columnStyles: { width: '15%' } },
    ];
    return (
      <Card
        title="Запросы на изменение к текущему приказу"
        category="Список всех запросов на изменение к текущему приказу"
        withoutPadding
        withoutBorder
      >
          <SimpleTable
            tableRows={tableRows}
            tableHeaders={tableHeaders}
            handleRowClick={handleOpenModal}
            placeholderIcon={EmptyListIcon}
            placeholderTitle="Нет запросов на изменение"
            placeholderText="Здесь будут отображаться все запросы на изменение информации о членах АПК"
            pagination={new PaginationImpl(props.expertChangeRequests).getPaginationData()}
            onPagination={props.getCurrentExpertChangeRequests}
          />
          {props.profile && props.details && (
            <InfoModal
              show={showExpertChangesModal}
              onHide={handleCloseModal}
              details={props.details}
              fetchExpertChangeRequestProcessing={fetchExpertChangeRequestProcessing}
              profile={props.profile}
            />
          )}
      </Card>
    );
};

const mapStateToProps = (state: IRootState) => ({
    expertChangeRequests: state.expertChanges.expertChangeRequests,
    details: state.expertChanges.details,
    profile: state.auth.auth ? state.auth.auth.profile : null,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getCurrentExpertChangeRequests: dispatch.expertChanges.getCurrentExpertChangeRequestsAsync,
    getExpertChangeRequest: dispatch.expertChanges.getExpertChangeRequest,
    clearExpertChangeRequest: dispatch.expertChanges.clearDetails,
});

type ConnectedProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
type IProps = ConnectedProps;

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTab);
